/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import FullTable from 'src/common/components/FullTable';
import notice from 'src/common/components/Notice';
import { columns, defaultFilter, filterForm } from './utils/list_data';
import PageLayout from 'src/common/components/PageLayout';
import { usersAPI } from 'src/api/modules/users';
import DeleteConsultModal from './DeleteConsultModal';
import { useSelector } from 'react-redux';
import { usePagination } from 'src/hooks/usePagination';

const Consult = () => {
	const history = useHistory();
	const location = useLocation();
	const [filter, setFilter] = useState(defaultFilter);
	const [miembros, setMiembros] = useState([]);
	const [modalDelete, setModalDelate] = useState(false);
	const [mounted, setMounted] = useState(false);
	const [IdUser, setIdUser] = useState();
	const [disableBoton, setDisableBoton] = useState(false);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [typeFilter, setTypeFilter] = useState();
	const [hideFilters, setHideFilters] = useState(false);
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const hideActions = [
		'RESPONSABLE CASIA',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'RESPONSABLE DE SEGUIMIENTO',
		'RESPONSABLE DE NEGOCIO',
	];

	const {
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
		handlePagination,
	} = usePagination();

	useEffect(() => {
		if (hideActions.includes(systemLevelRole) === true) {
			setDisableBoton(true);
		}
		/* if (history.location.state !== null) {
			setHideFilters(true);
			usersAPI
				.get('predictivo?nombre=' + history.location.state + '&conorganos=false')
				.then((response) => {
					if (response.length > 0) {
						setMiembros(response);
					} else {
						notice('No se encontraron resultados', 'warning');
					}
				})
				.catch((e) => notice('Error al cargar los usuarios'));
		} */
	}, []);

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;
		let queryFilters = { ...filter };
		if (name === 'predictiveName') {
			filter.predictiveUser = '';
			queryFilters.predictiveUser = '';
		}
		if (name === 'predictiveUser') {
			filter.predictiveName = '';
			queryFilters.predictiveName = '';
		}
		queryFilters = { ...queryFilters, [name]: value };

		const params = new URLSearchParams();
		if (queryFilters.status) params.set('status', queryFilters.status);
		if (queryFilters.predictiveName)
			params.set('predictiveName', queryFilters.predictiveName);
		if (queryFilters.predictiveUser)
			params.set('predictiveUser', queryFilters.predictiveUser);
		setFilter({ ...filter, [name]: value });
		history.push({ search: params.toString() });
	};

	const onSearch = () => {
		let userPromise = null;
		if (filter.predictiveName !== '') {
			userPromise = usersAPI.get(
				'predictivo?nombre=' + filter.predictiveName + '&conorganos=false',
				{},
				pagination,
				currentPage
			);
			setTypeFilter(2);
		} else if (filter.predictiveUser !== '') {
			userPromise = usersAPI.get(
				'predictivo?usuario=' + filter.predictiveUser + '&conorganos=false',
				{},
				pagination,
				currentPage
			);
			setTypeFilter(3);
		} else return notice('Debe escribir algo sobre los filtros de usuario', 'info');

		notice('Cargando Usuarios', 'info');
		setMiembros([]);

		userPromise
			.then((response) => {
				if (response.usuarios.length > 0) {
					setTotalResults(response.totalRegistros);
					setMiembros(response.usuarios);
				} else {
					notice('No se encontraron resultados', 'warning');
				}
			})
			.catch((e) => notice('Error al cargar los usuarios'));
	};

	const onConfirmFilter = () => {
		let startDay = filter.start_date;
		let endDay = filter.end_date;
		if (startDay !== null && endDay === null) {
			return notice(
				'Si selecciona una fecha, debe seleccionar un rango de fechas',
				'danger'
			);
		}

		if (endDay !== null && startDay === null) {
			return notice(
				'Si selecciona una fecha, debe seleccionar un rango de fechas',
				'danger'
			);
		}

		notice('Cargando Usuarios', 'info');
		setMiembros([]);
		setTypeFilter(1);

		usersAPI
			.getFilterConsult(
				filter.status,
				startDay === null ? '' : startDay.toLocaleDateString('en-GB'),
				endDay === null ? '' : endDay.toLocaleDateString('en-GB'),
				pagination,
				currentPage
			)
			.then((response) => {
				if (response.usuarios.length > 0) {
					setMiembros(response.usuarios);
					setTotalResults(response.totalRegistros);
				} else {
					notice('No se encontraron resultados', 'warning');
				}
			})
			.catch((e) => notice('Error al cargar los usuarios'));
	};

	const onEye = (id) => history.push(`/administracion-de-usuarios/usuario/${id}`);

	const onDelete = () => {
		let data = {
			usuario: user.usuario,
			password: user.abc,
		};

		usersAPI
			.delete(IdUser, data)
			.then(() => {
				notice('Usuario Eliminado', 'success');
				if (typeFilter === 1) onConfirmFilter();
				if (typeFilter === 2) onSearch();
				if (typeFilter === 3) onSearch();
			})
			.catch((e) => notice('Ha ocurrido un error con su petición'));
		setModalDelate(false);
		setIdUser();
	};

	const onRepeat = (user) => {
		let newUser;

		if (user.tipo === 'EXT' && user.estatus === 'Baja')
			newUser = {
				...user,
				id_perfil: 6,
				perfilNombre: 'Consulta',
				estatus: 'A',
			};
		else
			newUser = {
				...user,
				estatus: user.estatus === 'Activo' ? 'I' : 'A',
			};

		const id = newUser.id;
		delete newUser.id;
		delete newUser.usuario;
		delete newUser.fechaCreacion;
		delete newUser.fechaUltimoAcceso;
		delete newUser.organos;
		delete newUser.correos;

		usersAPI
			.put(id, { ...newUser })
			.then((res) => {
				if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(res.mensaje)));
				else {
					notice('Estado Cambiado Correctamente', 'success');
					if (typeFilter === 1) onConfirmFilter();
					if (typeFilter === 2) onSearch();
					if (typeFilter === 3) onSearch();
				}
			})
			.catch((e) => {
				if (isDev) {
					if (e.response.status === 500) {
						notice('Ha ocurrido un error con su petición');
					} else notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));
				} else notice('Ha ocurrido un error con su petición');
			});
	};
	const onClear = () => {
		setFilter(defaultFilter);
		setMiembros([]);
	};
	const onModalDelete = (id) => {
		setModalDelate(true);
		setIdUser(id);
	};

	useEffect(() => {
		if (location.search.length > 2) {
			const params = new URLSearchParams(location.search);
			const status = params.get('status') || '';
			/* 			const start_date = params.get('start_date') || '';
			const end_date = params.get('end_date') || ''; */
			const predictiveName = params.get('predictiveName') || '';
			const predictiveUser = params.get('predictiveUser') || '';
			setFilter({ ...filter, status, predictiveName, predictiveUser });
		}
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			if ((filter.predictiveName || filter.predictiveUser) && !mounted) {
				onSearch();
				setMounted(true);
			} else if (filter.status && !mounted) {
				onConfirmFilter();
				setMounted(true);
			}
		}, 2000);
		return () => clearTimeout(timer);
	}, [filter]);

	useEffect(() => {
		if (mounted && (filter.predictiveName || filter.predictiveUser)) {
			onSearch();
		} else if (filter.status && mounted) {
			onConfirmFilter();
		}
	}, [pagination, currentPage]);

	return (
		<PageLayout>
			<FullTable
				title={
					hideFilters
						? 'Usuarios con el Nombre: ' + history.location.state
						: 'Editar Usuario'
				}
				items={miembros}
				keyField={'id'}
				columns={columns(onEye, onModalDelete, onRepeat, disableBoton)}
				filter={filter}
				filterForm={
					hideFilters ? '' : filterForm(onConfirmFilter, onClear, onSearch)
				}
				onFilterChange={handleChangeFilter}
				showPagination={hideFilters ? false : true}
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			<DeleteConsultModal
				open={modalDelete}
				setClose={setModalDelate}
				onDelete={onDelete}
			/>
		</PageLayout>
	);
};

export default Consult;
